import { Swiper, Pagination, EffectFade, Autoplay } from 'swiper/js/swiper.esm';
import AOS from 'aos';

Swiper.use([Pagination, EffectFade, Autoplay]);

export default {
    init() {
        // const navigation = document.querySelectorAll('.navigation__menu');
        const toggleButton = document.querySelectorAll('[data-navigation-toggle]');
        // const menuItems = document.querySelectorAll('.navigation__menu .menu-item');

        // menuItems.forEach((item, index) => {
        //     item.style.transitionDelay = index * 80 + 'ms';
        // });

        toggleButton.forEach((item) => {
            item.addEventListener('click', () => {
                if (document.body.classList.contains('navigation-open')) {
                    // navigation.delay(300).fadeOut(300, 'Power4.easeInOut', function () {
                    document.body.classList.remove('navigation-open');
                    // });
                } else {
                    // navigation.fadeIn(300, 'Power4.easeInOut', function () {
                    document.body.classList.add('navigation-open');

                    // menuItems.each(function (index) {
                    //     $(this)
                    //         .delay(index * 80)
                    //         .css({'opacity': 0, 'bottom': -40})
                    //         .animate({
                    //             opacity : 1,
                    //             bottom: 0
                    //         }, 300, 'Power4.easeInOut');
                    // });
                    // });
                }

                return false;
            }, true);
        });

        // window.addEventListener('resize', () => {
            //     if ( $(window).width() > 1000) {
            //         navigation.fadeOut(400).removeClass('Navigation--open');
            //
            //         menuItem.each(function (index) {
            //             $(this).css({'opacity': 0, 'bottom': -40})
            //         });
            //     };
        // });

        // $(window).resize(function () {
        //     if ( $(window).width() > 1000) {
        //         navigation.fadeOut(400).removeClass('Navigation--open');
        //
        //         menuItem.each(function (index) {
        //             $(this).css({'opacity': 0, 'bottom': -40})
        //         });
        //     };
        // });

    },

    finalize() {
        const imageContainers = document.querySelectorAll('[data-slider]');
        const sliders = [];

        imageContainers.forEach((item) => {
            if (item.querySelectorAll('img').length > 1) {
                sliders.push(new Swiper(item, {
                    init: false,
                    speed: 1000,
                    loop: true,
                    slidesPerView: 1,
                    centeredSlides: true,
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false,
                    },
                    // spaceBetween: 20,
                    // direction: 'vertical',
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                }));
            }
        });

        const reviewsSlider = document.querySelector('[data-slider-reviews]');

    if (reviewsSlider) {
        sliders.push(new Swiper(reviewsSlider, {
            init: false,
            speed: 1000,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        }));
    }

        // JavaScript to be fired on all pages, after page specific JS is fired
        let aos_offset = 150;

        AOS.init({
            startEvent: 'DOMContentLoaded',
            offset: aos_offset,
            duration: 400,
            easing: 'ease-out-quad',
            delay: 300,
        });

        const runAfterDOMReady = () => {
            setTimeout(() => {
                if (sliders && sliders.length) {
                    sliders.forEach((item) => {
                        item.init();
                    });
                }
            }, 0);
            AOS.refresh();
            document.body.classList.remove('loading');
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', runAfterDOMReady);
        } else {
            runAfterDOMReady();
        }

        // Refresh AOS after images load so fade-ins use correct layout; fallback if load never fires
        window.addEventListener('load', () => AOS.refresh());
        setTimeout(() => AOS.refresh(), 2000);

        const products = document.querySelectorAll('.product, .blog .post, [data-link-hover]');

        products.forEach((product) => {
            const hoverTriggers = product.querySelectorAll('.woocommerce-loop-product__link, .woocommerce-loop-product__footer .add_to_cart_button, .woocommerce-loop-product__footer .product_type_variable, .entry-header, .entry-footer .button, .entry-thumbnail, [data-link-hover-trigger]');

            hoverTriggers.forEach((hoverTrigger) => {
                hoverTrigger.addEventListener('mouseenter', () => {
                    // console.log('enter');
                    product.classList.add('hover');
                }, true);
            });

            hoverTriggers.forEach((hoverTrigger) => {
                hoverTrigger.addEventListener('mouseleave', () => {
                    // console.log('leave');
                    product.classList.remove('hover');
                }, true);
            });
        });

        const videos = $('[data-video-url]');

        videos.each((index, video) => {
            $(video).on('click', video, (event) => {
                event.preventDefault();
                this.playSelectedVideo(video);
            });
        });
    },

    playSelectedVideo(videoTrigger) {
        const thisVideoLink = $(videoTrigger);
        const thisVideoUrl = thisVideoLink.data('video-url');
        let targetDiv = thisVideoLink.closest('.column__video');

        if (0 === targetDiv.size()) {
            targetDiv  = thisVideoLink.closest('.Text-Block__image');
        }

        if ( thisVideoLink.data('video-target') && ( '' !== thisVideoLink.data('video-target') ) ) {
            targetDiv  = $('#' + thisVideoLink.data('video-target'));
        }

        targetDiv.addClass('responsive-video');
        targetDiv.addClass('video-playing');

        // hide this
        if ( thisVideoLink.data('hide-me') ) {
            thisVideoLink.hide();
        }

        // deeplink
        if ( thisVideoLink.data('deeplink')  ) {
            // save
            window.location.hash = 'video=' + thisVideoUrl;
            // scroll to top
            $('html, body').stop().animate({scrollTop:0}, '500', 'swing');
        }

        // stop old
        targetDiv.html('');
        $('.video_currently_playing').removeClass('video_currently_playing');
        thisVideoLink.addClass('video_currently_playing');

        // iframe - vimeo
        if ( thisVideoUrl.indexOf('vimeo') > 0 ) {
            let embedUrl   = thisVideoUrl.split('/');
            embedUrl       = embedUrl[ embedUrl.length - 1 ];

            // iframe - vimeo
            targetDiv.html('<iframe src="//player.vimeo.com/video/'+embedUrl+'?title=0&amp;byline=0&amp;portrait=0&amp;autoplay=1" width="100%" height="100%" allowfullscreen></iframe>');
            return false;
        }

        // iframe - youtube
        if ( thisVideoUrl.indexOf('youtube') > 0 ) {
            let embedUrl   = thisVideoUrl.split('?v=');
            embedUrl       = embedUrl[ embedUrl.length - 1 ];

            // iframe - vimeo
            targetDiv.html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+embedUrl+'?rel=0&amp;showinfo=0&amp;autoplay=true" allowfullscreen></iframe>');
            return false;
        }

        targetDiv.html('<video width="100%" height="100%" controls autoplay><source src="'+thisVideoUrl+'" type="video/mp4"></video>');

        return false;
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js